import { AlertCircle, CheckCircle, ClipboardList, Package } from 'lucide-react';

import { Card, CardContent } from 'shadcn/components/ui/Card';
import { Skeleton } from 'shadcn/components/ui/Skeleton';

function SummaryCard({ Icon, iconBgClass, iconColorClass, isLoading, title, value }) {
    return (
        <Card className="py-3">
            <CardContent className="flex items-center justify-between p-3">
                <div>
                    <p className="text-sm font-medium text-muted-foreground">{title}</p>
                    {isLoading ? <Skeleton className="h-8 w-16 mt-1" /> : <p className="text-2xl font-bold">{value}</p>}
                </div>
                <div className={`${iconBgClass} p-3 rounded-full`}>
                    <Icon className={`h-6 w-6 ${iconColorClass}`} />
                </div>
            </CardContent>
        </Card>
    );
}

function SummaryCards({ error, isLoading, prepCompletePallets, prepInboundPallets, totalPallets }) {
    if (error) {
        return (
            <div className="grid gap-4 md:grid-cols-3 mt-1">
                <Card className="md:col-span-3 py-3 bg-red-50 border-red-200">
                    <CardContent className="flex items-center justify-center p-3 text-red-700">
                        <AlertCircle className="h-6 w-6 mr-3" />
                        <p className="text-sm font-medium">Error: {error}</p>
                    </CardContent>
                </Card>
            </div>
        );
    }

    const cardData = [
        {
            title: 'Total Pallets',
            value: totalPallets,
            Icon: Package,
            iconBgClass: 'bg-blue-100',
            iconColorClass: 'text-blue-500',
        },
        {
            title: 'Prep Inbound',
            value: prepInboundPallets,
            Icon: ClipboardList,
            iconBgClass: 'bg-blue-100',
            iconColorClass: 'text-blue-500',
        },
        {
            title: 'Prep Complete',
            value: prepCompletePallets,
            Icon: CheckCircle,
            iconBgClass: 'bg-green-100',
            iconColorClass: 'text-green-500',
        },
    ];

    return (
        <div className="grid gap-4 md:grid-cols-3 mt-1">
            {cardData.map((card) => (
                <SummaryCard key={card.title} {...card} isLoading={isLoading} />
            ))}
        </div>
    );
}

export default SummaryCards;
